import React, { useEffect, useState } from 'react';
import Countries from '../assets/countriesJSON/countries.json';
import { useNavigate } from "react-router-dom";
import { FaBuilding } from 'react-icons/fa';
import ReactGooglePlacesAutocomplete from 'react-google-places-autocomplete';

const baseUrl = process.env.REACT_APP_API_URL;

export function List() {
  const auth = localStorage.getItem("auth");
  const authJsonObject = JSON.parse(auth);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [responseMessage, setResponseMessage] = useState(''); 
  const navigate = useNavigate();
  const [userType, setUserType] = useState('company'); 
  const [showPasswordPopup, setShowPasswordPopup] = useState(false); 
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState(''); 
  const [passwordSuccess, setPasswordSuccess] = useState(''); 
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phonenumber: '',
    company: '',
    companywebsite: '',   
    address: '',
    city: '',
    state: '',
    country: '',
    ZIPCode: '',
    geometryfile: '',
    companydetails: '',
    company_logo: '' ,
    provider_type: 'company',
     
  });
  const [originalData, setOriginalData] = useState(formData);
  const [logoSrc, setLogoSrc] = useState(null); 
    useEffect(() => {
      let isMounted = true;

      const fetchData = async () => {
        try {
          const token = authJsonObject["token"];
          const response = await fetch(`${baseUrl}/currentuser`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }); 

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

        const result = await response.json();
        if (isMounted) {
          const profileData = result.profile;
          const data = {
            firstname: profileData.firstname || '',
            lastname: profileData.lastname || '',
            email: profileData.email || '',
            phonenumber: profileData.phonenumber || '',
            company: profileData.company || '',
            companywebsite: profileData.companywebsite || '', 
            companydetails: profileData.companydetails || '',
            address: profileData.address || '',
            city: profileData.city || '',
            state: profileData.state || '',
            country: profileData.country || '',
            ZIPCode: profileData.ZIPCode || '',
            //services: profileData.services || [],
            geometryfile: profileData.geometryfile || '',
            company_logo: profileData.company_logo || '',
            provider_type: profileData.provider_type || 'company' 
          };
          setProfile(profileData);
          setFormData(data);
          setOriginalData(data);
          setLogoSrc(profileData.company_logo ? `data:image/png;base64,${profileData.company_logo}` : null);
          setUserType(profileData.provider_type || 'company');

        // Determine if all editable fields are empty
        const editableFields = ['firstname', 'lastname', 'phonenumber', 'company', 'companywebsite', 'address', 'city', 'state', 'country', 'ZIPCode', 'companydetails'];
        const allEmpty = editableFields.every(field => !data[field]);
        setIsEditing(allEmpty);  // Enter edit mode if all editable fields are empty
      }
    } catch (error) {
      setError(error.message);
      console.error('Error fetching user profile:', error);
    }
  };

      fetchData();

      return () => {
        isMounted = false;
      };
    }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value || '',  // Ensure no null values
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate the file type - only allow image files (PNG, JPEG, etc.)
      const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validImageTypes.includes(file.type)) {
        setResponseMessage('Please upload a valid image file (JPEG or PNG)');
        return;
      }
  
      setFormData((prevState) => ({
        ...prevState,
        company_logo: file,
      }));
  
      // Create a temporary URL for the file to display it
      const fileUrl = URL.createObjectURL(file);
      setLogoSrc(fileUrl);
    }
  };
  

  const handleUserTypeChange = (e) => {
    const userTypeValue = e.target.value;
    setUserType(userTypeValue);
    setFormData((prevState) => ({
      ...prevState,
      provider_type: userTypeValue,  // Update provider_type in formData
    }));
  };
  const saveUserDetails = async () => {
    // List of required fields
    const requiredFields = ['firstname', 'lastname', 'phonenumber', 'company', 'address', 'city', 'state', 'country', 'ZIPCode', 'companydetails'];
  
    const emptyFields = requiredFields.filter(field => !formData[field]);
  
    if (emptyFields.length > 0) {
      setResponseMessage('The following fields are required: ' + emptyFields.join(', '));
      return;
    }
  
    try {
      const token = authJsonObject["token"];
      const formDataObj = new FormData();
  
      Object.keys(formData).forEach((key) => {
        if (key === 'company_logo' && formData[key]) {
          formDataObj.append('company_logo', formData[key]); 
        } else {
          formDataObj.append(key, formData[key] || '');
        }
      });
  
      const response = await fetch(`${baseUrl}/update_currentuser`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataObj,
      });
  
      if (!response.ok) {
        const errorDetail = await response.text();

        // Check if the error message indicates "No changes made to the user details"
        if (response.status === 400 && errorDetail.includes('No changes made to the user details')) {
          navigate('/termsofuse');  // Redirect to home if no changes were made
          return;
        }        
        throw new Error(`HTTP error! status: ${response.status}, details: ${errorDetail}`);
      }
  
     // const result = await response.json();
  
      setProfile(formData);
      setOriginalData(formData);
  
      setIsEditing(false);
  
      setResponseMessage('User details updated successfully.');
      navigate('/termsofuse');
  
    } catch (error) {
      setResponseMessage(`Error updating user details: ${error.message}`);
      console.error('Error updating user details:', error);
    }
  };
  


  const startEditing = () => {
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setFormData(originalData);
    setIsEditing(false);
  };

  const editableFields = ['firstname', 'lastname', 'phonenumber', 'company', 'companywebsite', 'address', 'city', 'state', 'country', 'ZIPCode', 'companydetails'];
  const allEditableFieldsEmpty = editableFields.every(field => !formData[field]);

  const openPasswordPopup = () => {
    setShowPasswordPopup(true);
    setPasswordError(''); // Clear errors when opening
    setPasswordSuccess('');
  };

  // Close the password popup
  const closePasswordPopup = () => {
    setShowPasswordPopup(false);
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
  
    if (newPassword.length < 6) {
      setPasswordError('Password must be at least 6 characters long.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError('Passwords do not match.');
      return;
    }
  
    try {
      const token = authJsonObject["token"];
      const response = await fetch(`${baseUrl}/change_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      setPasswordSuccess('Your password has been successfully changed.');
  
      // Delay closing the popup for 2 seconds to show the success message
      setTimeout(() => {
        closePasswordPopup();
      }, 2000);
  
    } catch (error) {
      setPasswordError('Error changing password: ' + error.message);
    }
  };  
  
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="user-profile-container">
      <h1>Provider Profile Details</h1>
      <p>Please ensure this information is accurate, as it will be visible to the customers.</p>
      <div className="button-container">
        {profile && !isEditing && (
          <button
            onClick={startEditing}
            className="btn btn-primary me-2"
          >
            Edit User Details
          </button>
        )}
        <button onClick={openPasswordPopup} className="btn btn-primary">
          Change Password
        </button>
      </div>
      {/* Display response message */}
      {responseMessage && (
        <div className="alert alert-info" role="alert">
          {responseMessage}
        </div>
      )}

      <div className="radio-buttons">
        <div>
          <label className="radio-button-label">
            <input
              type="radio"
              name="userType"
              value="individual"
             checked={userType === 'individual'}
              onChange={handleUserTypeChange}
            />
            Are you Individual?
          </label>
        </div>
        <div>
          <label className="radio-button-label">
            <input
              type="radio"
              name="userType"
              value="company"
              checked={userType === 'company'}
              onChange={handleUserTypeChange}
            />
            Are you Company?
          </label>
        </div>
      </div>

      {profile ? (
        <table className="table table-striped">
          <tbody>
          <tr>
  <td>Company Logo</td>
  <td>
    <div className="logo-container">
      {isEditing ? (
        <>
          {/* Placeholder for the company logo */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '10px',
            }}
          >
            {logoSrc ? (
              <img src={logoSrc} alt="Company Logo" />
            ) : (
              <FaBuilding size={48} color="#ccc" /> // Placeholder icon
            )}
          </div>
          {/* File input */}
          <input
            type="file"
            name="company_logo"
            onChange={handleFileChange}
            className="file-input"
            accept=".jpg,.jpeg,.png"
          />
        </>
      ) : (
        logoSrc ? (
          <img src={logoSrc} alt="Company Logo" style={{ width: '100px', height: 'auto' }} />
        ) : (
          <FaBuilding style={{ fontSize: '48px', color: '#ccc' }} /> // Placeholder icon
        )
      )}
    </div>
  </td>
</tr>

            <tr>
            <td>{userType === 'company' ? 'Company' : 'Pilot'}</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="company"
                    value={formData.company || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.company || 'N/A'
                )}
              </td>
            </tr>
            <tr>
              <td>Website</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="companywebsite"
                    value={formData.companywebsite || ''}
                    onChange={handleChange}
                  />
                ) : (
                  formData.companywebsite ? (
                    <a
                      href={formData.companywebsite.startsWith('http') ? formData.companywebsite : `http://${formData.companywebsite}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formData.companywebsite}
                    </a>
                  ) : (
                    'N/A'
                  )
                )}
              </td>
            </tr>
          
            <tr>
            <td>{userType === 'company' ? 'Company Details' : 'Pilot Details'}</td>
              <td>
                {isEditing ? (
                  <textarea
                    name="companydetails"
                    value={formData.companydetails || ''}
                    onChange={handleChange}
                    placeholder= "What are the most important things you want customers to understand about your company?" 
                    style={{
                      width: '100%',
                      height: '100px',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      boxSizing: 'border-box',
                      resize: 'none',
                      transition: 'border-color 0.3s',
                      backgroundColor: 'transparent',
                    }}
                  />
                ) : (
                  <div
                  style={{
                    backgroundColor: '#f9f9f9',  // Light gray background when not editing
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    width: '100%', // Full width
                    height: '100px', // Consistent height with textarea
                    overflowY: 'auto', // Scroll if content overflows
                  }}
                  >
                    {profile.companydetails || 'N/A'}
                  </div>
                )}
              </td>
            </tr>
            <tr>
              <td>Email</td>
              <td>
                  {profile.email}
              </td>
            </tr>
            <tr>
              <td>Contact First Name</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="firstname"
                    value={formData.firstname || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.firstname || 'N/A'
                )}
              </td>
            </tr>
            <tr>
              <td>Contact Last Name</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="lastname"
                    value={formData.lastname || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.lastname || 'N/A'
                )}
              </td>
            </tr>
            <tr>
              <td>Phone Number</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="phonenumber"
                    value={formData.phonenumber || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.phonenumber || 'N/A'
                )}
              </td>
            </tr>
            <tr>
              <td>Address</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="address"
                    value={formData.address || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.address || 'N/A'
                )}
              </td>
            </tr>
            <tr>
          <td>City</td>
          <td>
            {isEditing ? (
              <ReactGooglePlacesAutocomplete
              apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                selectProps={{
                  value: formData.city ? { label: formData.city, value: formData.city } : null,
                  onChange: (value) => {
                    setFormData((prevState) => ({
                      ...prevState,
                      city: value ? value.label : '',
                    }));
                  },
                }}
              />
            ) : (
              profile.city || 'N/A'
            )}
          </td>
        </tr>

            <tr>
              <td>State / Province</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="state"
                    value={formData.state || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.state || 'N/A'
                )}
              </td>
            </tr>
            <tr>
              <td>ZIP Code</td>
              <td>
                {isEditing ? (
                  <input
                    type="text"
                    name="ZIPCode"
                    value={formData.ZIPCode || ''}
                    onChange={handleChange}
                  />
                ) : (
                  profile.ZIPCode || 'N/A'
                )}
              </td>
            </tr>
            <tr>
              <td>Country</td>
              <td>
                {isEditing ? (
                  <select
                    name="country"
                    value={formData.country || ''}
                    onChange={handleChange}
                  >
                    <option value="">Select Country</option>
                    {Object.entries (Countries).map(([key, value], index) => (
                      <option key={index} value={key}>
                      {value}
                      </option>
                    ))}
                  </select>
                ) : (
                  profile.country || 'N/A'
                )}
              </td>
            </tr>
            
            <tr>
              <td>Service Area KML File</td>
              <td>
              <a href={profile.geometryfile} download="geometry_file.kml" target="_blank" rel="noopener noreferrer">
                {profile.geometryfile}
                </a>
                </td>
            </tr> 
          </tbody>
        </table>
      ) : (
         <div>Loading...</div>
      )}
                {/* {isEditing && (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                      onClick={saveUserDetails}
                      className="btn btn-primary"
                      disabled={!logoSrc && allEditableFieldsEmpty} // Disable when no logo and all editable fields are empty
                    >
                    Go to Step 5 <br/>
                    (Terms and Conditions)
                    </button>
        </div>
      )} */}

<div style={{ display: 'flex', justifyContent: 'center' }}>
  <button
    onClick={saveUserDetails}
    className="btn btn-primary"
    disabled={!logoSrc && allEditableFieldsEmpty} // Keep existing disable logic
  >
    Go to Step 5 <br />
    (Terms and Conditions)
  </button>
</div>

    {showPasswordPopup && (
  <div className="popup-overlay">
    <div className="popup-content">
      <h2>Change Password</h2>
      <form onSubmit={handleChangePassword}>
        <div className="form-group">
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="form-control"
          />
        </div>
        {passwordError && <p className="error-text">{passwordError}</p>}
        {passwordSuccess && <p className="success-text">{passwordSuccess}</p>}
        <div className="button-group">
          <button type="submit" className="btn btn-primary">Change Password</button>
          <button type="button" onClick={closePasswordPopup} className="btn btn-secondary">Close</button>
        </div>
      </form>
    </div>
  </div>
)}
    </div>
  );
}
